"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Search = void 0;
var _react = _interopRequireDefault(require("react"));
var _Input = require("../Input");
var _Icons = require("../Icons");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var Search = _ref => {
  var className = _ref.className,
    placeholder = _ref.placeholder,
    queryString = _ref.queryString,
    onQueryStringChange = _ref.onQueryStringChange,
    isDisabled = _ref.isDisabled;
  return /*#__PURE__*/_react.default.createElement(_Input.Input, {
    className: className,
    onChange: onQueryStringChange,
    startEnhancer: /*#__PURE__*/_react.default.createElement(_Icons.IconSearchMd, {
      size: 16
    }),
    value: queryString,
    placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : 'Search',
    isDisabled: isDisabled
  });
};
exports.Search = Search;
//# sourceMappingURL=Search.js.map